import React, { useState, useEffect } from "react";
import { FolderOpen } from 'lucide-react';
import Util from './Util';
import './ImageSelect.css'

const ImageSelect = ({ isOpen, onClose, onSave, onLogout, auth, demo, aspectLock, rectData, excludeSvg, onScrollOpen}) => {
  const [formData, setFormData] = useState({
    rect: rectData
  });
  const [fileList, setFileList] = useState([]);  // To store list of HTML filenames
  const [isWaitingForFiles, setIsWaitingForFiles] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);  // For showing the modal
  const [imageName, setImageName]=useState(rectData.imageName);
  const [aspectState, setAspectState] = useState(false);
  const [popupState, setPopupState] = useState(false);


  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    if (onSave) 
    {
        rectData.imageName = imageName;
        rectData.imagePanX = 0;
        rectData.imagePanY = 0;
        rectData.imageZoom = 1;
        setFormData("rect", rectData);
        onSave(formData);
    }
    onClose();
  };


  useEffect(() => {    
    setAspectState(rectData.keepAspect);
    setPopupState(rectData.enablePopup);

  },[])
  

  if (!isOpen) return null;

  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50,
    },
    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    },
    label: { display: "block", marginBottom: "15px", fontSize: "14px" },
    input: {
      display: "block",
      width: "100%",
      padding: "6px 10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    colorInput: {
      display: "inline-block",
      width: "60px",
      height: "35px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer",
    },
    modalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "6px 12px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
    },
    cancel: { backgroundColor: "#e0e0e0" },
    save: { backgroundColor: "#007bff", color: "#fff" },
  };

  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials:  demo===true ? "omit" : "include",  // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };


  const handleOpenImage =  (fileName) => {

    if(fileName === 'None')
    {
      setImageName('');
    }
    else
    {
        setImageName(fileName);
    }
    //rectData.imageName = fileName;
    setIsImageModalOpen(false);
    if(onScrollOpen)
    {
      onScrollOpen(false);
    }
  }


  const getImageResources = async () => {
    setIsWaitingForFiles(true);
    let command = Util.serverName + "/protected/getUserDirList";
    if(demo === true)
    {
      command = Util.serverName + "/api/getUserDirList";
    }
    
    try {
      const response = await fetchWithAuth(command, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (!response.ok) {
        setIsWaitingForFiles(false);
        return;
      }

      if (!data.status) {
        setIsWaitingForFiles(false);
        return;
      }

      let u = Util.getInstance();
      let fileArray = data.files;
      let imgA = [];
      imgA.push("None");

      fileArray.forEach((img) => {
        let type = u.getImageTypeFromFilename(img);
        if(type !== 'Unknown')
        {
          if(excludeSvg !== undefined && excludeSvg === true)
          {
          
            if(type !== 'SVG')
            {
              imgA.push(img);
            }
          }
          else
          {
            imgA.push(img);
          }
        }
        /*
        if(u.getImageTypeFromFilename(img) != 'Unknown')
        {
            imgA.push(img);
        }
        */
      });

      setFileList(imgA);
      setIsWaitingForFiles(false);
    } 
    catch (error) 
    {
      console.log("Error thrown:", error);
    }
  };

  
  async function handleListImages()
  {  
    await getImageResources();
    setIsImageModalOpen(true);
    if(onScrollOpen)
    {
      onScrollOpen(true);
    }
  }

  
  function handleCheckboxChange (e)
  {
    console.log("check State: ", e.target.checked);
    rectData.keepAspect = e.target.checked;
    setFormData("rect", rectData);
    setAspectState(!aspectState);
  }

  function handlePopupChange (e)
  {
    console.log("check State: ", e.target.checked);
    rectData.enablePopup = e.target.checked;
    setFormData("rect", rectData);
    setPopupState(!popupState);
  }

  function renderImageInfo()
  {
      let imgSrc= ""; 

      if(imageName != '')
      {
        if(demo === true)
        {

          imgSrc=`https://ait.myaiweb.ca/images/${imageName}`;
        
        }
        else
        {
          imgSrc=`https://myaiweb.ca/${auth.user.webId}/${imageName}`;
        }
      }

      return (
        <div>
          <button              
            onClick={() => handleListImages()}
            
            className="one-button"
            title="Select Image"
          >
            <FolderOpen size={18}> </FolderOpen> 
            {imageName}
          </button>

          <div style={{ width: '100%', maxWidth: '600px' }}>
            <div
              style={{
                width: '100%',
                height: '300px', // match RichTextEditor height
                border: '2px dashed #ccc',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden', // prevent image overflow
                color: '#999',
                fontStyle: 'italic'
              }}
            >
              {imageName !== '' ? (
                <img                  
                  src={imgSrc}
                  alt="Selected"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain' // keep aspect ratio
                  }}
                />
              ) : (
                'No image selected'
              )}
            </div>
          </div>
        </div>
      )

  }


  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2>Select Image</h2>

        {renderImageInfo()}
        {!aspectLock && (
            <label>
              <input
                type="checkbox"
                checked={aspectState}
                onChange={handleCheckboxChange}
              />
              Keep Aspect
            </label> )
        }

        <label>
          <input
            type="checkbox"
            checked={popupState}
            onChange={handlePopupChange}
          />
          Enable Image popup
        </label>



      {/* File Modal */}
      {isImageModalOpen && (
        <div 
          className="modalM">
          <div className="modalM-content">
            <h2>Select an Image</h2>

            <div className="file-list-container"
                  id = "scroll-list"
              >
              <ul className="image-file-list">
                {fileList.map((file) => (
                  <li key={file}>
                    <button
                      className="image-file-item"
                      onClick={() => handleOpenImage(file)}
                    >


                    {file !== "None" && (
                      <img
                          src={`https://myaiweb.ca/${auth.user.webId}/${file}`}                          
                          alt={file}
                          className="image-thumbnail"
                        />
                      )}
                      {file === "None" && (
                        <span className="image-thumbnail"></span>
                      )}
                      <span>{file}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <button
              className="close-button"
              onClick={() => {
                if(onScrollOpen)
                {
                  onScrollOpen(false);
                }
                setIsImageModalOpen(false)}}
            >
              Close
            </button>
          </div>
        </div>
      )}              
      {/* File Modal */}
      {/*
      {isImageModalOpen && (
        <div className="modalM">
          <div className="modalM-content">
            <h2>Select a Image</h2>
            <div className="file-list-container">
              <ul>
                {fileList.map((file) => (
                  <li key={file}>
                    <button onClick={() => handleOpenImage(file)}>{file}</button>
                  </li>
                ))}
              </ul>
            </div>
            <button className="close-button" onClick={() => setIsImageModalOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}

                */}
        
        {/* Buttons */}
        <div style={styles.modalButtons}>
          <button style={{ ...styles.button, ...styles.cancel }} onClick={onClose}>
            Cancel
          </button>
          <button style={{ ...styles.button, ...styles.save }} onClick={handleSave}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageSelect;


